import { render, staticRenderFns } from "./EditGroups.vue?vue&type=template&id=a3b90518&scoped=true&"
import script from "./EditGroups.vue?vue&type=script&lang=js&"
export * from "./EditGroups.vue?vue&type=script&lang=js&"
import style0 from "./EditGroups.vue?vue&type=style&index=0&id=a3b90518&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b90518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VFlex,VLayout,VProgressCircular})
